import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const state = () => {
    return {}
}

const store = new Vuex.Store({
    state,
    plugins: [createPersistedState({
        storage: window.sessionStorage,
        reducer(state) {
            return {
                index: state.index
            }
        }
    })]
})


export default store
